import { render } from "./oai-view-component.vue?vue&type=template&id=74e552a8&scoped=true&ts=true"
import script from "./oai-view-component.vue?vue&type=script&lang=ts"
export * from "./oai-view-component.vue?vue&type=script&lang=ts"

import "./oai-view-component.vue?vue&type=style&index=0&id=74e552a8&scoped=true&lange=scss&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e552a8"]])

export default __exports__